export const apiName: string = 'pontos';
export const pontosRoute: string = 'pontos';
export const pontosStorage: string = 'pontos';
export const pontosModuleName: any = {plural: 'Pontos', single: 'Ponto'};

export const apiNamePontosDeslocamento: string = 'pontos-deslocamentos';


export const pontosQuery: any = {
    "where":{
        "ativo":true,
        "nome":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"nome"
};

export const tiposPontos: any[] = [
    {"Key": 1, "Value": "Partida"},
    {"Key": 2, "Value": "Passagem"},
    {"Key": 3, "Value": "Final"}
];


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/pontos/shared/data.service.ts
 **/